import { Typography } from "@material-tailwind/react"
import logo from "../../assets/logo_only.png";
import { WBLabel } from "./WBLabel";
import { FaFacebook, FaInstagram, FaLocationDot, FaPhone, FaTiktok, FaYoutube } from "react-icons/fa6";

import { toast } from "react-toastify";
import LogoName from "./LogoName";

export default function Footer ({
    showSiteMap = false
}) {
    const CURRENT_YEAR = new Date().getFullYear();
    return (
        <footer className="pt-0 pb-8 mt-8 lg:mt-24">
            <div className="h-[0.5px] bg-[#80808080] mt-8 mb-8"/>
            <div className="container px-6 flex flex-col text-center md:px-12">
                {
                    showSiteMap &&
                    <div className="text-left mb-12">
                        <div className="flex md:hidden items-center justify-between">
                            <div className="flex items-center">
                                <img src={logo} width={48} height={48} />
                                {/* <WBLabel size={18} bold text={"Maxx Property"}/> */}
                                <LogoName fontSize={14}/>
                            </div>
                            <div className="flex text-right">
                                <div className="flex" onClick={() => { toast('coming soon') }}>
                                    <FaInstagram className="mt-1 mr-2 text-[20px]"/>
                                </div>
                                <div className="flex" onClick={() => { toast('coming soon') }}>
                                    <FaYoutube className="mt-1 mr-2 text-[20px]"/>
                                </div>
                                <div className="flex" onClick={() => { toast('coming soon') }}>
                                    <FaFacebook className="mt-1 mr-2 text-[20px]"/>
                                </div>
                                <div className="flex" onClick={() => { toast('coming soon') }}>
                                    <FaTiktok className="mt-1 mr-2 text-[20px]"/>
                                </div>
                            </div>
                        </div>
                        <div className="grid grid-cols-2 md:grid-cols-4 ">
                            <div className="hidden grid gap-3 md:block">
                                <div className="flex items-center mb-4">
                                    <img src={logo} width={48} height={48} />
                                    {/* <WBLabel size={18} bold text={"Maxx Property"}/> */}
                                    <LogoName fontSize={14}/>
                                </div>
                                <div className="flex" onClick={() => { toast('coming soon') }}>
                                    <FaInstagram className="mt-1 mr-2"/> Instagram
                                </div>
                                <div className="flex" onClick={() => { toast('coming soon') }}>
                                    <FaYoutube className="mt-1 mr-2"/> Youtube
                                </div>
                                <div className="flex" onClick={() => { toast('coming soon') }}>
                                    <FaFacebook className="mt-1 mr-2"/> Facebook
                                </div>
                                <div className="flex" onClick={() => { toast('coming soon') }}>
                                    <FaTiktok className="mt-1 mr-2"/> Tiktok
                                </div>
                            </div>
                            <div className="mt-4">
                                <div className="font-bold mb-2 text-[18px] md:text-[20px]">Tautan</div>
                                <div className="cursor-pointer" onClick={() => { window.location.href = "/" }}><WBLabel size={16} className={"mt-2 text-[grey]"}text={"Beranda"}/></div>
                                <div className="cursor-pointer" onClick={() => { window.location.href = "/listing" }}><WBLabel size={16} className={"mt-2 text-[grey]"} text={"Rumah Dijual"}/></div>
                                <div  className="cursor-pointer"onClick={() => { window.location.href = "/about-us" }}><WBLabel size={16} className={"mt-2 text-[grey]"} text={"Tentang Kami"}/></div>
                            </div>
                            <div className="mt-4">
                                <div className="font-bold mb-2 text-[18px] md:text-[20px]">Sering dikunjungi</div>
                                <div className="cursor-pointer" onClick={() => { window.location.href = "/listing" }} ><WBLabel size={16} className={"mt-2 text-[grey]"} text={"Rumah Dijual"} /></div>
                                {/* <div className="cursor-pointer" onClick={() => { window.location.href = "/proyek" }} ><WBLabel size={16} className={"mt-2 text-[grey]"} text={"Rumah Baru"} /></div> */}
                            </div>
                            <div className="mt-4">
                                <div className="font-bold mb-2 text-[18px] md:text-[20px]">Informasi</div>
                                <div className="cursor-pointer" onClick={() => { window.location.href = "/about-us" }}><WBLabel size={16} className={"mt-2 text-[grey]"} text={"Tentang Kami"} /></div>
                                <div className="hidden md:block text-[14px] text-left md:text-left md:text-[16px]">
                                    <WBLabel size={10} bold text={"Visit Us : "} className={"mt-2"}/>
                                    <div className="flex cursor-pointer text-blue-maxx font-normal text-[14px]" onClick={() => {
                                        let outsideLink = document.createElement('a');
                                        outsideLink.target= '_blank';
                                        outsideLink.href= 'https://maps.app.goo.gl/CoxvpD4iENHBLdpe6';
                                        outsideLink.click();
                                    }}><FaLocationDot className="mt-1 mr-2 text-gold" size={40}/> Komplek Tritura Mas, Jalan AH Nasution No.A 12 A, Harjosari II, Kec. Medan Amplas, Kota Medan, Sumatera Utara 20228</div>
                                    <WBLabel size={10} bold text={"Contact Us : "} className={"mt-2"}/>
                                    <div className="flex cursor-pointer text-[14px]" onClick={() => {
                                        let outsideLink = document.createElement('a');
                                        outsideLink.target= '_blank';
                                        outsideLink.href= `tel:08116380281`;
                                        outsideLink.click();
                                    }}><FaPhone className="mt-1 mr-2 text-gold"/>+628116380281</div>
                                </div>
                            </div>
                        </div>
                        <div className="md:hidden text-[14px] text-left md:text-left md:text-[16px]">
                            <WBLabel size={10} bold text={"Visit Us : "} className={"mt-2"}/>
                            <div className="flex cursor-pointer text-blue-maxx font-normal text-[14px]" onClick={() => {
                                let outsideLink = document.createElement('a');
                                outsideLink.target= '_blank';
                                outsideLink.href= 'https://maps.app.goo.gl/CoxvpD4iENHBLdpe6';
                                outsideLink.click();
                            }}><FaLocationDot className="mt-1 mr-2 text-gold" size={40}/> Komplek Tritura Mas, Jalan AH Nasution No.A 12 A, Harjosari II, Kec. Medan Amplas, Kota Medan, Sumatera Utara 20228</div>
                            <WBLabel size={10} bold text={"Contact Us : "} className={"mt-2"}/>
                            <div className="flex cursor-pointer text-[14px]" onClick={() => {
                                let outsideLink = document.createElement('a');
                                outsideLink.target= '_blank';
                                outsideLink.href= `tel:08116380281`;
                                outsideLink.click();
                            }}><FaPhone className="mt-1 mr-2 text-gold"/>+628116380281</div>
                        </div>
                    </div>
                }
                <Typography
                    color="blue-gray"
                    className="text-[12px] md:text-sm md:text-center font-normal !text-gray-700"
                >
                    &copy; All rights reserved. Copyright © {CURRENT_YEAR} Maxx Property.
                </Typography>
            </div>
        </footer>
    )
}